import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["quantity", "cost", "rowTotal", "orderTotal", "monthTotal"]
  static values = {
    tableId: String,
    rowId: String
  }

  connect() {
    this.numbersOnlyPattern = /[^0-9.-]+/g
  }

  updateQuantityCost(event) {
    const dataCell = event.target
    const rowElement = dataCell.closest('tr')
    const tableElement = dataCell.closest('table')

    if (!rowElement || !tableElement) return

    const rowID = rowElement.id
    const tableID = tableElement.id

    this.calculateRowTotal(dataCell, rowElement)
    this.calculateOrderTotal(tableID)
    this.calculateMonthTotal(tableID)
  }

  calculateRowTotal(dataCell, rowElement) {
    let total = 0
    const isQuantityField = dataCell.dataset.element === 'quantity'
    const isCostField = dataCell.dataset.element === 'cost'

    if (!isQuantityField && !isCostField) return

    const multiplierSelector = isQuantityField ? 'input[data-element="cost"]' : 'input[data-element="quantity"]'
    const multiplierInput = rowElement.querySelector(multiplierSelector)

    if (multiplierInput && multiplierInput.value !== '' && dataCell.value !== '') {
      const multiplierValue = parseFloat(multiplierInput.value.replace(this.numbersOnlyPattern, ''))
      const currentValue = parseFloat(dataCell.value.replace(this.numbersOnlyPattern, ''))

      if (!isNaN(multiplierValue) && !isNaN(currentValue)) {
        total = multiplierValue * currentValue
      }
    }

    const rowTotalElement = rowElement.querySelector('td.row-total')
    if (rowTotalElement) {
      rowTotalElement.textContent = total.toString()
    }
  }

  calculateOrderTotal(tableID) {
    let orderTotal = 0
    const tableElement = document.getElementById(tableID)

    if (!tableElement) return

    const rowTotalElements = tableElement.querySelectorAll('td.row-total')

    rowTotalElements.forEach(rowTotal => {
      const value = parseFloat(rowTotal.textContent.replace(this.numbersOnlyPattern, ''))
      if (!isNaN(value)) {
        orderTotal += value
      }
    })

    const totalID = tableID.replace('item-table-', '')
    const orderTotalElement = document.getElementById(`total-purchase-${totalID}`)

    if (orderTotalElement) {
      orderTotalElement.textContent = `$${orderTotal}`
    }
  }

  calculateMonthTotal(tableID) {
    const totalID = tableID.replace('item-table-', '')
    const orderTotalElement = document.getElementById(`total-purchase-${totalID}`)

    if (!orderTotalElement) return

    const orderMonth = orderTotalElement.dataset.month
    if (!orderMonth) return

    let monthTotal = 0
    const monthElement = document.getElementById(orderMonth)

    if (monthElement) {
      const orderTotalElements = monthElement.querySelectorAll('div.order-total')

      orderTotalElements.forEach(orderMonthTotal => {
        const text = orderMonthTotal.textContent.trim()
        if (text !== '' && text !== '0') {
          const value = parseFloat(text.replace(this.numbersOnlyPattern, ''))
          if (!isNaN(value)) {
            monthTotal += value
          }
        }
      })

      const monthTotalElement = document.getElementById(`${orderMonth}-total`)
      if (monthTotalElement) {
        monthTotalElement.textContent = `$${monthTotal}`
      }
    }
  }
}
